import AdvertiserActions from '../../../../actions/AdvertiserActions';
import RegionsActions from '../../../../actions/RegionsActions';
import store from '../../../../stores/redux';
import config from '../../../../config';
import query from '../../../../helpers/query';
import { getRegionIds } from '../helpers';

export const actions = {
    update(state) {
        let params = {
            ...query.parseToSend(state)
        };

        const trimmedSearch = state.searchString?.trim() || '';
        if (trimmedSearch.length >= 2) {
            params.offer_goal_q = trimmedSearch;
        }

        AdvertiserActions.getGoalEntries(params, () => {
            const goalEntries = store.getState().goalEntries.list;
            let regionIds = getRegionIds(goalEntries);

            regionIds && RegionsActions.searchRegions({
                ids: regionIds,
                count: config.itemsCountPerPage
            });
        });
    }
};
